import s from './ClosedSchedule.module.scss';

export default function ClosedSchedule({ message }) {
  return (
    <div className={s.wrapper}>
      <div className="container">
        <div className="row">
          <div className="col-xs-12">
            <div className="formatted-text">
              {message ? (
                <div dangerouslySetInnerHTML={{ __html: message }} />
              ) : (
                <p>Please stay tuned as we get closer to the show</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
